import OwnerContentPage from '@/pages/OwnerContentPage/OwnerContentPage';

export default OwnerContentPage;
